import { useTheme } from '@mui/material'

import { Checkbox, FormControlLabel, FormGroup, Icons } from '../../components'

export function Filters({
  showGrantRequests,
  setShowGrantRequests,
  showRGrantRequests,
  setShowRGrantRequests,
  showContributions,
  setShowContributions,
  showRContributions,
  setShowRContributions,
  showBalanceAdjustements,
  setShowBalanceAdjustements,
  showDafTransfers,
  setShowDafTransfers,
  showRDafTransfers,
  setShowRDafTransfers,
  showGiveGenius,
  setShowGiveGenius,
  showInvestmentTransfers,
  setShowInvestmentTransfers,
}) {
  const theme = useTheme()
  const accentColor = theme.palette.accent.main
  const secondaryColor = theme.palette.secondary.main
  const primaryColor = theme.palette.primary.main

  return (
    <FormGroup
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        '& .MuiCheckbox-root': { paddingRight: '6px' /* down from 9px */ },
        '& .MuiFormControlLabel-label [data-icon]': { fontSize: '1em !important' },
      }}
    >
      {setShowGrantRequests && (
        <FilterItem
          checked={showGrantRequests}
          setChecked={setShowGrantRequests}
          icon={<Icons.GrantRequest style={{ color: accentColor }} />}
          text="Gifts"
        />
      )}
      {setShowRGrantRequests && (
        <FilterItem
          checked={showRGrantRequests}
          setChecked={setShowRGrantRequests}
          icon={<Icons.GrantRequest style={{ color: accentColor }} />}
          text="Recurring Gifts"
        />
      )}
      {setShowContributions && (
        <FilterItem
          checked={showContributions}
          setChecked={setShowContributions}
          icon={<Icons.Contribution style={{ color: secondaryColor }} />}
          text="Contributions"
        />
      )}
      {setShowRContributions && (
        <FilterItem
          checked={showRContributions}
          setChecked={setShowRContributions}
          icon={<Icons.Contribution style={{ color: secondaryColor }} />}
          text="Recurring Contributions"
        />
      )}
      {setShowBalanceAdjustements && (
        <FilterItem
          checked={showBalanceAdjustements}
          setChecked={setShowBalanceAdjustements}
          icon={<Icons.BalanceAdjustment style={{ color: primaryColor }} />}
          text="Balance Adjustments"
        />
      )}
      {setShowDafTransfers && (
        <FilterItem
          checked={showDafTransfers}
          setChecked={setShowDafTransfers}
          icon={<Icons.GiftCard style={{ color: accentColor }} />}
          text="Shared Funds"
        />
      )}
      {setShowRDafTransfers && (
        <FilterItem
          checked={showRDafTransfers}
          setChecked={setShowRDafTransfers}
          icon={<Icons.DafTransfer style={{ color: secondaryColor }} />}
          text="Recurrent Shared Funds"
        />
      )}
      {setShowInvestmentTransfers && (
        <FilterItem
          checked={showInvestmentTransfers}
          setChecked={setShowInvestmentTransfers}
          icon={<Icons.InvestmentTransfer style={{ color: primaryColor }} />}
          text="Investment Transfers"
        />
      )}
    </FormGroup>
  )
}

export function FilterItem({ icon, text, checked, setChecked }) {
  return (
    <FormControlLabel
      size="small"
      checked={checked}
      onChange={(event) => setChecked(event?.target?.checked)}
      control={<Checkbox />}
      label={
        <>
          {icon} {text}
        </>
      }
    />
  )
}
